<div class="page-container">
  <app-back-link link="/settings" label="Back to Settings"></app-back-link>
  <app-page-header title="Fish Types">
    <button mat-stroked-button (click)="startAdd()" [disabled]="editingId !== null">
      <mat-icon>add</mat-icon> Add Fish Type
    </button>
  </app-page-header>

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
  <div class="error-panel" *ngIf="errorMessage">{{ errorMessage }}</div>

  <div class="table-scroll" *ngIf="!isLoading && !errorMessage">
    <table mat-table [dataSource]="dataSource" class="fish-table">
      
      <!-- Color Column -->
      <ng-container matColumnDef="color">
        <th mat-header-cell *matHeaderCellDef class="col-color"></th>
        <td mat-cell *matCellDef="let ft" [class.inactive-row]="ft.id !== -1 && !ft.active && editingId !== ft.id">
          <ng-container *ngIf="editingId === ft.id">
            <input type="color" [(ngModel)]="editForm.display_color" class="color-input" />
          </ng-container>
          <ng-container *ngIf="editingId !== ft.id">
            <span class="color-swatch" [style.background-color]="ft.fish_display_color"></span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let ft" [class.inactive-row]="ft.id !== -1 && !ft.active && editingId !== ft.id">
          <ng-container *ngIf="editingId === ft.id">
            <input type="text" [(ngModel)]="editForm.my_name" placeholder="e.g. rockfish" class="text-input" />
          </ng-container>
          <ng-container *ngIf="editingId !== ft.id">
            <span class="name-cell">{{ ft.fish_name }}</span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Display Name Column -->
      <ng-container matColumnDef="full_name">
        <th mat-header-cell *matHeaderCellDef>Display Name</th>
        <td mat-cell *matCellDef="let ft" [class.inactive-row]="ft.id !== -1 && !ft.active && editingId !== ft.id">
          <ng-container *ngIf="editingId === ft.id">
            <input type="text" [(ngModel)]="editForm.full_name" placeholder="e.g. Striped Rockfish" class="text-input" />
          </ng-container>
          <ng-container *ngIf="editingId !== ft.id">
            <span>{{ ft.fish_full_name ?? '—' }}</span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Other Names Column -->
      <ng-container matColumnDef="other_names">
        <th mat-header-cell *matHeaderCellDef>Other Names</th>
        <td mat-cell *matCellDef="let ft" [class.inactive-row]="ft.id !== -1 && !ft.active && editingId !== ft.id">
          <ng-container *ngIf="editingId === ft.id">
            <input type="text" [(ngModel)]="editForm.other_names" placeholder="Optional" class="text-input" />
          </ng-container>
          <ng-container *ngIf="editingId !== ft.id">
            <span class="other-names-cell">{{ ft.other_names ?? '—' }}</span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let ft" [class.inactive-row]="ft.id !== -1 && !ft.active && editingId !== ft.id">
          <ng-container *ngIf="editingId === ft.id">
            <label class="active-toggle">
              <input type="checkbox" [(ngModel)]="editForm.active" /> Active
            </label>
          </ng-container>
          <ng-container *ngIf="editingId !== ft.id">
            <span class="status-badge" [class.status-active]="ft.active" [class.status-inactive]="!ft.active">
              {{ ft.active ? 'Active' : 'Disabled' }}
            </span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="col-actions"></th>
        <td mat-cell *matCellDef="let ft" class="action-cell" [class.inactive-row]="ft.id !== -1 && !ft.active && editingId !== ft.id">
          <ng-container *ngIf="editingId === ft.id">
            <button mat-stroked-button class="save-btn" (click)="ft.id === -1 ? saveNew() : saveEdit(ft.id)" [disabled]="isSaving || !editForm.my_name.trim()">
              {{ isSaving ? 'Saving…' : 'Save' }}
            </button>
            <button mat-stroked-button class="cancel-btn" (click)="cancelEdit()" [disabled]="isSaving">Cancel</button>
          </ng-container>
          <ng-container *ngIf="editingId !== ft.id">
            <button mat-stroked-button class="edit-btn" (click)="startEdit(ft)" [disabled]="editingId !== null">
              Edit
            </button>
            <button mat-stroked-button (click)="toggleActive(ft)" [disabled]="editingId !== null"
                    [class.enable-btn]="!ft.active" [class.disable-btn]="ft.active">
              {{ ft.active ? 'Disable' : 'Enable' }}
            </button>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.edit-row]="editingId === row.id"></tr>
    </table>
  </div>
</div>
